import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchCustomInputsBulk } from "#modules/quoteRequestLines/infra/fetchCustomInputsBulk.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const customInputsBulkQuery = (quoteRequestId: string | undefined) => ({
  queryKey: queryKeys.quoteRequests.customInputsBulk(quoteRequestId),
  queryFn: () => fetchCustomInputsBulk(quoteRequestId),
  staleTime: STALE_TIME,
  enabled: !!quoteRequestId,
});
